import { FlaskConical } from "lucide-react";
import { useBreakpoint } from "@marekl/adminer/hooks";
import { isTestInstance } from "../../lib/environment";
import styles from "./EnvironmentChip.module.css";

const EXPLANATION = "Změny se nepromítnou do ostrého systému a e-maily se neodesílají.";

/**
 * The words that go with the test palette, inside the top bar (AppTopbar),
 * so the shell gains no strip that pushes the page down. The striped bar
 * behind it comes from `--adminer-topbar-bg` in tokens.css. Pages without a
 * top bar get `EnvironmentBanner` instead.
 */
export function EnvironmentChip({ show = isTestInstance }: { show?: boolean }) {
  const isPhone = useBreakpoint() === "sm";
  if (!show) return null;
  return (
    <span className={styles.chip} role="note" title={EXPLANATION} data-testid="environment-chip">
      <FlaskConical size={14} aria-hidden="true" />
      {isPhone ? "Test" : "Testovací prostředí"}
      <span className={styles.srOnly}>. {EXPLANATION}</span>
    </span>
  );
}
